const initialState = {
    basket: [],
    wishlist: []
};

const reducer = (state = initialState, action) =>  {
    // console.log(action.item);
    switch (action.type) {
        case "ADD_TO_CART":
            return {
                ...state, 
                basket: [...(state.basket || []), action.item]
            }

        case "REMOVE_FROM_CART":
            const basketItemIndex = state.basket.findIndex(basketItem => basketItem.id === action.id);
            let newBasket = [...state.basket];

            if(basketItemIndex >= 0){
                newBasket.splice(basketItemIndex, 1);
            } else {
                console.warn(`There is no basket item with the id ${action.id}`);
            }

            return {
                ...state.basket,
                basket: newBasket
            }

        case "REMOVE_FROM_WISH":
            const wishlistItemIndex = state.wishlist.findIndex(wishlistItem => wishlistItem.id === action.id);
            let newWishlist = [...state.wishlist];

            if(wishlistItemIndex >= 0){
                newWishlist.splice(wishlistItemIndex, 1);
            } else {
                console.warn(`There is no basket item with the id ${action.id}`);
            }

            return {
                ...state.wishlist,
                wishlist: newWishlist
            }

        case "ADD_TO_WISH":
            return {
                ...state, 
                wishlist: [...(state.wishlist || []), action.item]
            }
    
        default:
            return {
                state
            }
    }
}

export default reducer;